<template>
  <component :is="component"></component>
</template>
<script>

import Func31Listagem from '@/views/31/Func31Listagem'

export default {
  name: 'Func31',
  data () {
    return {
      component: Func31Listagem
    }
  }
}
</script>
